/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-properties */
// DEPRECATED Removed in DEV-26311.
// This file is used only for backward compatibility. Add new functions to /shared/functions/*.ts instead

import get from 'lodash/get';
import set from 'lodash/set';
import { SubmissionError } from 'redux-form/immutable';
import Linkify from 'linkifyjs/react';

import { agentPrefix, chromeExtensionIds, grayColor, systemErrorCodes } from 'shared/constants';
import { adaptIsTerminal, stringifyIfObject } from 'shared/functions/utils';
// eslint-disable-next-line import/no-default-export
import { logError, getPathInValues } from 'shared/functions';

import errorField from 'assets/images/error.png';
import missingField from 'assets/images/missing_fields.png';

const errorPopupMessage = (
  <div
    className="small margin-top"
    style={{
      lineHeight: '1.5em',
    }}
  >
    <div>If you need more information,</div>
    please contact us.
  </div>
);

const twilioExtensionIds = () => [
  ...chromeExtensionIds,
  ...(localStorage.extensionId ? [localStorage.extensionId] : []),
];
export const twilioExtensionOnline = () =>
  Promise.all(
    twilioExtensionIds().map(
      (extensionId) =>
        window.chrome.runtime &&
        new Promise((resolve) =>
          window.chrome.runtime.sendMessage(extensionId, { command: 'version' }, (reply: any) =>
            resolve(reply && reply.version),
          ),
        ),
    ),
  ).then((responses) => responses.some((response) => response));
export const makeTwilioCall = async (
  modalAlert: any,
  phoneNumber: any,
  name: any,
  avatar: any,
  chatUrl: any,
  candidateId: any,
) =>
  (await twilioExtensionOnline())
    ? twilioExtensionIds().forEach((chromeExtensionId) =>
        window.chrome.runtime.sendMessage(chromeExtensionId, {
          command: 'call',
          phoneNumber,
          name,
          avatar,
          chatUrl,
          candidateId,
        }),
      )
    : modalAlert.open(
        <div>
          {translate('Twilio Chrome extension required to make a phone calls. Please install or enable it.')}
          <a
            style={{ display: 'block' }}
            href={`https://chrome.google.com/webstore/detail/luckylink-twilio-chrome-e/${chromeExtensionIds[0]}`}
            target={window.hrefTarget}
          >
            {translate('Chrome Web Store (download)')}
          </a>
        </div>,
        translate('Twilio extension not installed!'),
      );

const errorHasPath = (error: any) => get(error, 'path', []).length;

export const linkifyError = (error: any) => {
  const candidateMatch = /#candidate.*?#/gi.exec(error) || [];
  const contactMatch = /#contact.*?#/gi.exec(error) || [];
  const candidateId = (candidateMatch[0] || '').replace('#candidate', '').replace('#', '');
  const contactId = (contactMatch[0] || '').replace('#contact', '').replace('#', '');
  const makeLink = (entitiesType: any, userId: any) =>
    `${window.location.origin}${agentPrefix}/${entitiesType}?userId=${userId}`;
  if (candidateId || contactId) {
    return (
      <Linkify>
        <span
          dangerouslySetInnerHTML={{
            __html: error
              .replace(/#candidate.*?#/gi, candidateId ? makeLink('candidates', candidateId) : '')
              .replace(/#contact.*?#/gi, contactId ? makeLink('contacts', contactId) : ''),
          }}
        />
      </Linkify>
    );
  }
  return error;
};

const mapErrorWithUnknownPath = (noPathError: any, index: any) => {
  if (noPathError.message) {
    return (
      <div key={index}>
        <strong>{noPathError.path.join('.')}</strong>: {noPathError.message}
      </div>
    );
  }
  return typeof noPathError === 'object' ? JSON.stringify(noPathError) : noPathError;
};

const mapErrorWithoutPath = (errorWithoutPath: any, index: any) => {
  if (errorWithoutPath.message) {
    return <div key={index}>{errorWithoutPath.message}</div>;
  }
  return typeof errorWithoutPath === 'object' ? JSON.stringify(errorWithoutPath) : `${errorWithoutPath}`;
};

const pathNotFound = 'path-not-found';
export const wrappedProcessValidationErrors = (values: any, jsValues: any, errorData: any) => {
  const { status, payload } = errorData || {};
  const { handled, error, errors } = payload || {};

  if (error) {
    window.setNotificationComponent(
      <div>
        <img
          src={errorField}
          alt=""
          style={{
            maxWidth: '110px',
            marginTop: '-10px',
          }}
        />
        <h3 className="text-danger">
          {translate(status === 401 ? 'Operation is not allowed' : 'Oops, something went wrong')}
        </h3>
        <div className="text-black margin-bottom">
          {typeof error === 'object' && JSON.stringify(error, null, 1)}
          {typeof error !== 'object' && error}
        </div>
        {errorPopupMessage}
      </div>,
    );
    throw new SubmissionError({ _error: stringifyIfObject(error) });
  } else if (errors) {
    if (handled) {
      return;
    }

    const nonSystemErrors = errors.filter((item: any) => !systemErrorCodes.includes(item.code));
    const errorsWithPath = [];
    const errorsWithoutPath = [];
    nonSystemErrors.forEach((item: any) => (errorHasPath(item) ? errorsWithPath : errorsWithoutPath).push(item));

    const errorsWithUnknownPath = [];
    const fieldsErrors = errorsWithPath.reduce((prev, cur) => {
      const pathInValues = getPathInValues(values, cur.path);
      const pathAsArray = pathInValues.split('.');
      const childKey = pathAsArray.pop();
      if (!(childKey in (pathAsArray.length ? get(values, pathAsArray) : values)) && !cur.patchedId) {
        errorsWithUnknownPath.push(cur);
      } else {
        const setError = (value: any, curPath: any) => {
          const valueIsObject = value && typeof value === 'object' && !Array.isArray(value);
          const errorPostfix = valueIsObject ? '._error' : '';
          set(prev, `${curPath}${errorPostfix}`, cur.message);
        };
        setError(get(values, pathInValues, pathNotFound), pathInValues);
      }
      return prev;
    }, {});
    if (errorsWithUnknownPath.length) {
      window.setNotificationComponent(
        <div>
          <img
            src={missingField}
            alt=""
            style={{
              maxWidth: '140px',
              marginTop: '-10px',
            }}
          />
          <h3 className="text-danger">{translate('Missing field error occurred')}</h3>
          <div className="text-black margin-bottom">{errorsWithUnknownPath.map(mapErrorWithUnknownPath)}</div>
          {errorPopupMessage}
        </div>,
      );
    } else if (errorsWithoutPath.length) {
      window.setNotificationComponent(
        <div>
          <img
            src={errorField}
            alt=""
            style={{
              maxWidth: '110px',
              marginTop: '-10px',
            }}
          />
          <h3 className="text-danger">{translate('Unhandled server error occurred')}</h3>
          <div className="text-black margin-bottom">{errorsWithoutPath.map(mapErrorWithoutPath)}</div>
          {errorPopupMessage}
        </div>,
      );
    }
    const unexpectedErrors = [...errorsWithUnknownPath, ...errorsWithoutPath];
    throw new SubmissionError({
      _error: unexpectedErrors.length
        ? unexpectedErrors.map((item) => item.message).join('\n')
        : translate('Form validation failed!'),
      ...fieldsErrors,
    });
  }
};

export const processValidationErrors =
  (values = {}, jsValues = {}) =>
  (...args: any[]) => {
    try {
      return wrappedProcessValidationErrors(values, jsValues, args[0]);
    } catch (err) {
      if (err instanceof SubmissionError) {
        throw err;
      }

      logError(err, {
        validationError: args[0],
        values,
      });

      window.setNotificationComponent(
        <div>
          <img
            src={missingField}
            alt=""
            style={{
              maxWidth: '140px',
              marginTop: '-10px',
            }}
          />
          <h3 className="text-danger">{translate('Unhandled format error occurred')}</h3>
          {`${err}`}
        </div>,
      );
    }
  };

export const loadingAlert = () => (
  <h3
    className="text-center"
    style={{
      padding: '50px',
      margin: 0,
    }}
  >
    {translate('Loading')}...
  </h3>
);
export const renderTextOrHtml = (textOrHtml: any) =>
  /(<([^>]+)>)/gi.test(textOrHtml || '') ? (
    <div dangerouslySetInnerHTML={{ __html: textOrHtml }} />
  ) : (
    <div style={{ whiteSpace: 'pre-wrap' }}>{textOrHtml}</div>
  );
export const mapLegendBlock = (block: any) => (
  <p key={block.label}>
    <span
      className="legend-item"
      style={{
        background: block.background,
      }}
    />{' '}
    {block.label}
  </p>
);
export const displayNameOptionRenderer = (option: any) =>
  option.name ? option.name.displayName : <i className="fa fa-spin fa-spinner text-muted" />;

export const renderEmail = (email: any) => (
  <span
    className="text-overflow"
    style={{
      maxWidth: '100%',
      display: 'inline-block',
    }}
  >
    {email ? (
      <a href={`mailto:${email.emailAddress}`} title={email.emailAddress}>
        {email.emailAddress}
      </a>
    ) : (
      ''
    )}
  </span>
);

export const getWorkflowStateOptionRenderer = (showStage?: any, showWorkflow?: any) => (initialOption: any) => {
  const { normalizedPipelineWorkflows, normalizedPipelineStages } = window.settings;
  const option = initialOption || {};
  const workflow = normalizedPipelineWorkflows[option.workflowId] || {};
  const workflowStage = normalizedPipelineStages[option.workflowStageId] || {};
  const label = [showWorkflow && workflow.name, showStage && workflowStage.name, option.name]
    .filter(Boolean)
    .join(': ');
  return (
    <span>
      <i className="fa fa-circle margin-right" style={{ color: option.color || grayColor }} />
      {label} {adaptIsTerminal(option.isTerminal)} {option.disabledFrom ? `(${translate('Disabled')})` : ''}
    </span>
  );
};

export const highlightedSpan = (highlights: any, text: any, defaultValue: any) => {
  if (!highlights) {
    return defaultValue || text;
  }
  let __html = text;
  if (highlights[text]) {
    __html = highlights[text];
  } else if (text) {
    // Elasticsearch highlight phrase can be bugged
    Object.keys(highlights).forEach((highlight) => {
      if (text.includes(highlight)) {
        __html = text.replace(highlight, highlights[highlight]);
      }
    });
  }
  return <span dangerouslySetInnerHTML={{ __html }} />;
};

export const stateBadge = (state: any) => (
  <span
    className="badge show-label"
    style={{
      background: state.color,
    }}
  >
    <span>{state.name}</span>
  </span>
);

// TODO: uncomment hasActions in https://evadotai.atlassian.net/browse/DEV-22897
export const showWorkflowStateChangedPopup = (toWorkflowState?: any, entitiesLabel?: any) => {
  window.setNotificationComponent(
    <div className="text-left">
      <span className="notification-icon pull-left margin-right">
        <i className="lnr lnr-bullhorn" />
        <i className="ll-icon ll-logo-eva-small fa-2x text-primary" />
      </span>
      <h4 className="text-success margin-left pull-left">{translate('Success')}!</h4>
      <div className="clearfix" />
      {entitiesLabel} {translate('successfully moved to state')} {stateBadge(toWorkflowState)}
      {
        /* hasActions */ true && (
          <div className="small text-muted margin-top">
            {translate('Automated actions will be executed')}
            {' ~ '}
            {translate('in 5 minutes')} {translate('if they are linked to this transition')}
          </div>
        )
      }
    </div>,
  );
  setTimeout(() => window.setNotificationComponent(null), 6000);
};

export const EmptyDiv = () => <div />;

export const valuesWithDelimiter = (values: any) =>
  values
    .filter((value: any) => value)
    .map((value: any, index: any) => (
      <span key={index}>
        {!!index && <span className="margin-left margin-right fa fa-circle text-muted small-dots" />}
        {value}
      </span>
    ));

export const renderSection = (label: any, content: any) => (
  <div key={label} className="section">
    <h4 className={`${label ? '' : 'hide'}`}>{label}</h4>
    {content}
  </div>
);
